import React, { Component } from "react";
import { View, Animated, Text, Easing, StyleSheet } from "react-native";

import * as x from "../../styles/css";

class ProgressIndicator extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: new Animated.Value(0),
		};

		this.start = this.start.bind(this);
	}

    componentDidMount() {
        this.start();
    }

	start() {
		Animated.timing(this.state.width, {
			toValue: 100,
			easing: Easing.inOut(Easing.ease),
			duration: 1500,
		}).start(ani => {
			if (ani.finished && this.props.loading) {
				this.state.width.setValue(0);
				this.start();
			}
		});
	}

	render() {
		const marginleft = this.state.width.interpolate({
			inputRange: [0, 100],
            outputRange: ["0%", "100%"],
            extrapolate: "clamp"
        });
    
        const width = this.state.width.interpolate({
			inputRange: [0, 5, 10, 20, 30, 40, 50, 60, 90, 100],
            outputRange: [5, 30, 60, 90, 100, 100, 100, 100, 30, 0],
            extrapolate: "clamp"
		});

		return (
			<Animated.View
				style={[
                    x.d.flex,
					styles.body,
				]}
			>
            <Animated.View style={{height: "100%", width: width, marginLeft: marginleft, backgroundColor: this.props.color || x.colors.default}}/>
			</Animated.View>
		);
	}
}

const styles = StyleSheet.create({
	body: {
        width: "100%",
        height: 10,
		backgroundColor: "lightgray",
	},
	value: {
		color: "white",
		fontSize: 46,
		textAlign: "center",
	},
	name: {
		color: "white",
		fontSize: 16,
		textAlign: "center",
	},
});

export default ProgressIndicator;



// WEBPACK FOOTER //
// ./src/components/ProgressIndicator/index.js